export default __webpack_public_path__ + "e6671386ee357aa450ebbfc6350932b0.svg";